import { useCallback, useRef } from 'react';
import { useUpdate } from 'ahooks';
import isEqual from 'react-fast-compare';

function useStateFromProps({ value, defaultValue, onChange }) {
  const update = useUpdate();

  const valueRef = useRef(defaultValue ?? value);
  const stateRef = useRef(valueRef.current);

  if (value !== undefined && !isEqual(valueRef.current, value)) {
    stateRef.current = value;
  }

  valueRef.current = value;

  const setState = useCallback(v => {
    const nextValue = typeof v === 'function' ? v(stateRef.current) : v;

    if (isEqual(nextValue, stateRef.current)) return;
    stateRef.current = nextValue;
    update();
    onChange?.(nextValue);
  }, []);

  return [stateRef.current, setState];
}

export default useStateFromProps;
